import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { validateFloatInput } from '@gk/gk-modules';
import { MCGRNewRequestSettlementScopeControlName } from '../costs-section/costs-section-form.model';
import {
  MCGREstimatedWorksCostsFormGroup,
  MCGRNewRequestEstimatedWorksCostsControlName,
} from '../works-estimated-costs/works-estimated-costs-form.model';
import {
  MCGRNewRequestOtherSourceSettlementScopeControlName,
  MCGROtherSourceSettlementScopeFormGroup,
  OtherSourceSettlementScope,
} from './other-source-settlement-scope-form-array.model';
import { MCGROtherSourceSettlementScopeFormArrayService } from './other-source-settlement-scope-form-array.service';

@Component({
  selector: 'app-mcgr-other-source-settlement-scope-form-array',
  templateUrl: './other-source-settlement-scope-form-array.component.html',
  imports: [CommonModule, TranslateModule, ReactiveFormsModule],
})
export class MCGROtherSourceSettlementScopeFormArrayComponent {
  arrayControlName = MCGRNewRequestEstimatedWorksCostsControlName.OtherFunds;
  settlementScopeControlName = MCGRNewRequestSettlementScopeControlName;
  otherSourceSettlementScopeControlName =
    MCGRNewRequestOtherSourceSettlementScopeControlName;
  @Input() formGroup: FormGroup<MCGREstimatedWorksCostsFormGroup>;
  @Input() submitted: boolean;

  constructor(
    private mcgrOtherSourceSettlementScopeFormArrayService: MCGROtherSourceSettlementScopeFormArrayService,
  ) {}

  isFormGroupValid(index: number): boolean {
    const letterContentWithParcelsFormGroup = this.getFormArray().at(index);
    return letterContentWithParcelsFormGroup.valid;
  }

  deleteFormControl(index: number): void {
    this.getFormArray().removeAt(index);
  }

  getFormArray(): FormArray<
    FormGroup<MCGROtherSourceSettlementScopeFormGroup>
  > {
    return this.formGroup.get(this.arrayControlName) as FormArray<
      FormGroup<MCGROtherSourceSettlementScopeFormGroup>
    >;
  }

  addFormControl(): void {
    this.getFormArray().push(
      this.mcgrOtherSourceSettlementScopeFormArrayService.getFormGroup(),
    );
  }

  validateFloatInput(event: KeyboardEvent): void {
    if (!validateFloatInput(event.key)) {
      event.preventDefault();
    }
  }

  createFormArrayFromData(dataArray: OtherSourceSettlementScope[]): void {
    const formArray = this.getFormArray();
    formArray?.clear();
    dataArray?.forEach(() => {
      formArray.push(
        this.mcgrOtherSourceSettlementScopeFormArrayService.getFormGroup(),
      );
    });
  }
}
